import {graphql} from '~/graphql-react-query/';

export const PublicCreativeItem = graphql(`
    query CreativeItemV2($creativeId: ID!) {
        creativeV2 {
            publicCreativeItemV2(creativeId: $creativeId) {
                id
                creative
                firstAppeared
                lastAppeared
                status
                mediaOwnerList {
                    id
                    name
                }
                mediaTypeList {
                    id
                    name
                    canonicalName
                }
                publisherList {
                    id
                    name
                }
                publicationList {
                    id
                    name
                }
                regionList {
                    id
                    name
                }
                country
                placementTypes
                advertiserDomain
                aiExtractedTextV1
                aiTranscriptionTextV1
                aiAdTypeV1
                aiDemographicsV1 {
                    genderDistribution {
                        unspecified
                        female
                        male
                    }
                    ageBracket
                    ageName
                }
                aiSummaryInsightsV1 {
                    summary150
                    summary300
                }
                aiTagsV1 {
                    advertiser
                    industry
                    category
                    product
                }
                compliance {
                    compliance_code
                    compliance_code_id
                    compliance_risk_rating
                    compliance_reason
                }
            }
        }
    }
`);

export const ComplianceCreativeItem = graphql(`
    query ComplianceCreativeItemV2($creativeId: ID!) {
        creativeV2 {
            publicCreativeItemV2(creativeId: $creativeId) {
                id
                creative
                firstAppeared
                lastAppeared
                status
                mediaOwnerList {
                    id
                    name
                }
                mediaTypeList {
                    id
                    name
                    canonicalName
                }
                publisherList {
                    id
                    name
                }
                publicationList {
                    id
                    name
                }
                regionList {
                    id
                    name
                }
                country
                placementTypes
                advertiserDomain
                aiExtractedTextV1
                aiTranscriptionTextV1
                aiAdTypeV1
                aiDemographicsV1 {
                    genderDistribution {
                        unspecified
                        female
                        male
                    }
                    ageBracket
                    ageName
                }
                aiSummaryInsightsV1 {
                    summary150
                    summary300
                }
                aiTagsV1 {
                    advertiser
                    industry
                    category
                    product
                }
                compliance {
                    compliance_code
                    compliance_code_id
                    compliance_risk_rating
                    compliance_reason
                }
            }
        }
    }
`);

export const CreativeList = graphql(`
    query CreativeListV2($input: CreativeListInputV2!) {
        creativeV2 {
            creativeListV2(input: $input) {
                totalCount
                paginationInfo {
                    hasPreviousPage
                    hasNextPage
                    currentPage
                }
                items {
                    id
                    creative
                    firstAppeared
                    lastAppeared
                    status
                    mediaTypeList {
                        id
                        name
                        canonicalName
                    }
                    mediaOwnerList {
                        id
                        name
                    }
                    publisherList {
                        id
                        name
                    }
                    publicationList {
                        id
                        name
                    }
                    regionList {
                        id
                        name
                    }
                    country
                    placementTypes
                    advertiserDomain
                    aiExtractedTextV1
                    aiTranscriptionTextV1
                    aiAdTypeV1
                    aiCampaignHeadlineV1
                    aiDemographicsV1 {
                        genderDistribution {
                            unspecified
                            female
                            male
                        }
                        ageBracket
                        ageName
                    }
                    aiSummaryInsightsV1 {
                        summary150
                        summary300
                    }
                    aiTagsV1 {
                        advertiser
                        industry
                        category
                        product
                    }
                    compliance {
                        compliance_code
                        compliance_code_id
                        compliance_risk_rating
                        compliance_reason
                    }
                }
            }
        }
    }
`);

export const CreativeDownload = graphql(`
    query CreativeDownload($input: CreativeDownloadInput!) {
        creativeV2 {
            creativeDownload(input: $input) {
                downloadLink
            }
        }
    }
`);

export const SingleCreativeMediaValue = graphql(`
    query CreativeMediaValue($input: CreativeMediaValueInput!) {
        creativeV2 {
            creativeMediaValue(input: $input) {
                date
                normalizedSpend
            }
        }
    }
`);

export const GroupByCampaign = graphql(`
    query GroupByCampaign($input: GroupByCampaignInput!) {
        creativeV2 {
            groupByCampaign(input: $input) {
                items {
                    campaignName
                    creativeCount
                    thumbnailCreative
                    status
                    firstAppeared
                    lastAppeared
                    region
                    mediaType
                    publication
                    publisher
                    mediaOwner
                    aiAdType
                    aiProducts
                    aiCategories
                    aiIndustries
                    aiAdvertisers
                    country
                }
                paginationInfo {
                    afterKey
                    nextPageMayContainMoreCampaigns
                }
            }
        }
    }
`);
